import { DropdownMenu as M } from "radix-ui";
import type { ReactNode } from "react";
import { cn } from "./cn";

export interface MenuItem {
  label: ReactNode;
  icon?: ReactNode;
  onSelect: () => void;
  danger?: boolean;
  disabled?: boolean;
}

export function Menu({ trigger, items, label, align = "end" }: { trigger: ReactNode; items: (MenuItem | "separator")[]; label?: ReactNode; align?: "start" | "end" }) {
  return (
    <M.Root modal={false}>
      <M.Trigger asChild>{trigger}</M.Trigger>
      <M.Portal>
        <M.Content align={align} sideOffset={6} className="z-50 min-w-52 rounded-md border border-line bg-surface p-1 shadow-lg data-[state=open]:animate-fade-up">
          {label && <M.Label className="px-3 py-1.5 text-xs text-muted">{label}</M.Label>}
          {items.map((it, i) =>
            it === "separator" ? (
              <M.Separator key={i} className="my-1 h-px bg-line" />
            ) : (
              <M.Item
                key={i}
                disabled={it.disabled}
                onSelect={it.onSelect}
                className={cn(
                  "flex cursor-pointer items-center gap-2 rounded px-3 py-2 text-sm outline-none select-none data-[disabled]:opacity-40 data-[highlighted]:bg-brand-light [&_svg]:size-4",
                  it.danger ? "text-bad data-[highlighted]:bg-bad-light" : "text-ink",
                )}
              >
                {it.icon}
                {it.label}
              </M.Item>
            ),
          )}
        </M.Content>
      </M.Portal>
    </M.Root>
  );
}
